import { ProductionTypes } from './app-config-production-types';
import { IAppConfigStatic } from './app-config-static';
import { IAppConfigTracking } from './app-config-tracking';
import { IAppConfigTranslate } from './app-config-translate';
import { IApplicationInsights } from './app-application-insights';
import { IGoogleMaps } from './app-google-maps';

export abstract class AppConfig {
  public abstract readonly production: boolean;
  public abstract readonly productionType: ProductionTypes;
  public abstract readonly baseApiUrl: string;
  public abstract readonly baseNewApiUrl: string;
  public abstract readonly baseUrl: string;
  public abstract readonly translations: IAppConfigTranslate;
  public abstract readonly statics: IAppConfigStatic;
  public abstract readonly tracking: IAppConfigTracking;
  public abstract readonly applicationInsights: IApplicationInsights;
  public abstract readonly googleMaps: IGoogleMaps;
}
